export const CALL_ROUTER_BEHAVIOR_MODE_FAST_FORWARD = 1
export const CALL_ROUTER_BEHAVIOR_MODE_ALOAI = 2
export const CALL_ROUTER_BEHAVIOR_MODE_DEAD_END = 3
export const CALL_ROUTER_BEHAVIOR_MODE_IVR = 4
